<template>
    <el-drawer
        :title="`新增`"
        :visible.sync="show"
        direction="rtl"
        size="40%"
        :wrapperClosable="false"
        :before-close="close"
    >
        <div class="panel">
            <el-form
                ref="item"
                :model="item"
                :rules="rules"
                label-width="100px"
            >
                <el-form-item label="所属项目" prop="projectId">
                    <Select
                        :value="item.projectId"
                        :url="`/pbl/selectData/project`"
                        @optionChanged="this.optionChanged"
                        :bindDisabled="String(item.projectId)==''?false:true"
                    ></Select>
                </el-form-item>
                <el-form-item label="题目类型" prop="type">
                    <el-radio v-model="item.type" label="ESSAY_QUESTION"
                        >问答题</el-radio
                    >
                    <el-radio v-model="item.type" label="CHOICE_QUESTION"
                        >选择题</el-radio
                    >
                </el-form-item>
                <el-form-item label="题目" prop="question">
                    题目中附件也会被记为字数
                    <vue-neditor-wrap
                        v-model="item.question"
                        :config="editorConfig"
                        :destroy="false"
                    ></vue-neditor-wrap>
                </el-form-item>

                <template v-if="item.type === 'CHOICE_QUESTION'">
                    <el-form-item label="选项A" prop="answer1">
                        <vue-neditor-wrap
                            v-model="item.answer1"
                            :config="editorConfig"
                        ></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="选项B" prop="answer2">
                        <vue-neditor-wrap
                            v-model="item.answer2"
                            :config="editorConfig"
                        ></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="选项C" prop="answer3">
                        <vue-neditor-wrap
                            v-model="item.answer3"
                            :config="editorConfig"
                        ></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="选项D" prop="answer4">
                        <vue-neditor-wrap
                            v-model="item.answer4"
                            :config="editorConfig"
                        ></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="正确答案" prop="answer">
                        <el-select v-model="item.answer" placeholder="请选择">
                            <el-option label="A" value="A"></el-option>
                            <el-option label="B" value="B"></el-option>
                            <el-option label="C" value="C"></el-option>
                            <el-option label="D" value="D"></el-option>
                        </el-select>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="doInsert()">确定</el-button>
            <el-button @click="close()">取消</el-button>
        </span>
    </el-drawer>
</template>

<style scoped></style>

<script>
import Select from "@/components/Select.vue";
import VueNeditorWrap from "vue-neditor-wrap";

export default {
    components: { Select, VueNeditorWrap },
    props: ["onClose", "projectId"],
    data() {
        return {
            show: false,
            item: {
                projectId: this.projectId,
                type: "ESSAY_QUESTION",
                question: "",
                answer1: "",
                answer2: "",
                answer3: "",
                answer4: "",
                answer:""
            },
            rules: {
                projectId: [
                    {
                        validator: this.checkEmpty,
                        message: "请选择",
                        trigger: "change"
                    }
                ],
                question: [
                    {
                        validator: this.checkEmpty,
                        message: "请填写",
                        trigger: "change"
                    }
                ],
                answer1: [
                    {
                        validator: this.checkEmpty,
                        message: "请填写",
                        trigger: "change"
                    }
                ],
                answer2: [
                    {
                        validator: this.checkEmpty,
                        message: "请填写",
                        trigger: "change"
                    }
                ],
                answer3: [
                    {
                        validator: this.checkEmpty,
                        message: "请填写",
                        trigger: "change"
                    }
                ],
                answer4: [
                    {
                        validator: this.checkEmpty,
                        message: "请填写",
                        trigger: "change"
                    }
                ],
                answer: [
                    {
                        validator: this.checkEmpty,
                        message: "请选择正确答案",
                        trigger: "change"
                    }
                ]
            },
            editorConfig: {
                serverUrl: "/api/web/upload/ueditor",
                UEDITOR_HOME_URL: "/admin/NEditor/",
                autoHeightEnabled: false,
                initialFrameHeight: 200,
                initialFrameWidth: "100%",
                enableAutoSave: true,
                maximumWords: 2000
            }
        };
    },
    methods: {
        checkEmpty(rule, value, callback) {
            if (rule.field === "projectId") {
                let val = this.item.projectId || "";
                if (val === "") {
                    return callback(new Error("请选择"));
                }
                callback();
            }
            if (rule.field === "question") {
                let val = this.item.question || "";
                if (val === "") {
                    return callback(new Error("请填写"));
                }
                callback();
            }
            if (rule.field === "answer") {
                let val = this.item.answer || "";
                if (val === "") {
                    return callback(new Error("请选择正确答案"));
                }
                callback();
            }
            if (rule.field === "answer1") {
                let val = this.item.answer1 || "";
                if (val === "") {
                    return callback(new Error("请填写"));
                }
                callback();
            }
            if (rule.field === "answer2") {
                let val = this.item.answer2 || "";
                if (val === "") {
                    return callback(new Error("请填写"));
                }
                callback();
            }
            if (rule.field === "answer3") {
                let val = this.item.answer3 || "";
                if (val === "") {
                    return callback(new Error("请填写"));
                }
                callback();
            }
            if (rule.field === "answer4") {
                let val = this.item.answer4 || "";
                if (val === "") {
                    return callback(new Error("请填写"));
                }
                callback();
            }
        },
        close() {
            this.$emit("close");
        },
        doInsert() {
            this.$refs["item"].validate(valid => {
                if (valid) {
                    this.$ajaxPost(
                        "/pbl/lesson/institution/insert",
                        {
                            lesson: this.item
                        },
                        data => {
                            if (data && data.success) {
                                this.$showSuccess("操作成功");
                                this.$emit("submit");
                                this.$emit("close");
                            }
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        optionChanged(result) {
            this.item.projectId = result.value;
        }
    },
    mounted() {
        this.show = true;
    },
    created() {}
};
</script>
